import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getEntityLink } from 'helpers/getEntityLink';
import { TabSelector } from 'components/TabSelector';
import { Clients } from './Clients';
import { Coaches } from './Coaches';
import { Groups } from './Groups';
import styles from 'pages/Database/Database.scss';

export const PageSelector = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const dataTypes = [
    { label: 'Клієнти', value: 'clients', component: Clients },
    { label: 'Тренери', value: 'coaches', component: Coaches },
    { label: 'Групи', value: 'groups', component: Groups },
  ];

  const [activeDataTypeIndex, setActiveDataTypeIndex] = useState(
    dataTypes.findIndex((t) => pathname.split('/').includes(t.value))
  );

  useEffect(() => {
    navigate(getEntityLink(`database/${dataTypes[activeDataTypeIndex].value}`));
  }, [activeDataTypeIndex]);

  return (
    <TabSelector
      className={styles.dataSelector}
      defaultActiveIndex={activeDataTypeIndex}
      tabs={dataTypes.map((d) => d.label)}
      onTabChange={setActiveDataTypeIndex}
    />
  );
};
